module.exports = __webpack_public_path__ + "img/arrowStatus.d12fed15.svg";